// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__l3Quj","link":"HeaderSimple_link__bqVwu","linkSmall":"HeaderSimple_linkSmall__KkbBe","inputSearch":"HeaderSimple_inputSearch__JWOry"};